import * as R from 'ramda'
import { errorToBeAdded } from '../../reducers/error'

export const started = (tag, cancelToken) => ({ type: `${tag}_STARTED`, cancelToken })
export const ended = (tag) => ({ type: `${tag}_ENDED` })
export const response = (tag, params) => ({ type: `${tag}_SUCCESS`, ...params })

export const failure = (tag, error) => ({ type: `${tag}_FAILURE`, error })
export const reset = (tag) => ({type: `${tag}_RESET`,  results: [],});

export const call = (meta) => (dispatch) => {
  const { endpoint, inputs, action, messages, resetData = false } = meta
  if(resetData){
    dispatch(reset(action))
    return
  }
  dispatch(started(action))
  return endpoint(inputs)
    .then((success) => {
      dispatch(response(action, success))
      return success
    })
    .catch((error) => {
      dispatch(failure(action, error))
      dispatch(
        errorToBeAdded(
          error,
          messages.id,
          (error.response && error.response.data && error.response.data.message) || messages.failure
        )
      )
      throw error
    })
}

export const clearError = (state) => R.assoc('error', {}, state)
export const startLoading = (state) => R.assoc('loading', true, state)
export const stopLoading = (state) => R.assoc('loading', false, state)
export const saveErrorMsg = (state, action, message) =>
  R.assoc(
    'error',
    {
      message,
      error: action.error,
    },
    state
  )

export const loadStarted = (tag, cancelToken) => ({ type: `LOAD_${tag}_STARTED`, cancelToken })
export const loadEnded = (tag) => ({ type: `LOAD_${tag}_ENDED` })
export const loadSuccess = (tag, params) => ({ type: `LOAD_${tag}_SUCCESS`, ...params })

export const loadFailure = (tag, error) => ({ type: `LOAD_${tag}_FAILURE`, error })

export const reducer =
  (initialState, tag, success, failure) =>
  (state = initialState, action) => {
    switch (action.type) {
      case `${tag}_STARTED`: {
        return startLoading(clearError(state))
      }
      case `${tag}_SUCCESS`: {
        return success(stopLoading(state), action)
      }
      case `${tag}_FAILURE`: {
        return saveErrorMsg(stopLoading(state), action, failure)
      }
      case `${tag}_RESET`: {
       return success(stopLoading(state), { results: [] });
      }
      default:
        return state
    }
  }
